export default {
    getUrlParameter(key: string) : string|null {
        const uri = window.location.search.substring(1);
        const params = new URLSearchParams(uri);
        return params.get(key);
    }
}
